/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class ProcessDefinitionsApi extends BaseApi {
    createIdentityLink(processDefinitionId, identityLinkRepresentation) {
        throwIfNotDefined(processDefinitionId, 'processDefinitionId');
        throwIfNotDefined(identityLinkRepresentation, 'identityLinkRepresentation');
        const pathParams = {
            processDefinitionId
        };
        return this.post({
            path: '/api/enterprise/process-definitions/{processDefinitionId}/identitylinks',
            pathParams,
            bodyParam: identityLinkRepresentation
        });
    }
    deleteIdentityLink(processDefinitionId, family, identityId) {
        throwIfNotDefined(processDefinitionId, 'processDefinitionId');
        throwIfNotDefined(family, 'family');
        throwIfNotDefined(identityId, 'identityId');
        const pathParams = {
            processDefinitionId,
            family,
            identityId
        };
        return this.delete({
            path: '/api/enterprise/process-definitions/{processDefinitionId}/identitylinks/{family}/{identityId}',
            pathParams
        });
    }
    getIdentityLinkType(processDefinitionId, family, identityId) {
        throwIfNotDefined(processDefinitionId, 'processDefinitionId');
        throwIfNotDefined(family, 'family');
        throwIfNotDefined(identityId, 'identityId');
        const pathParams = {
            processDefinitionId,
            family,
            identityId
        };
        return this.get({
            path: '/api/enterprise/process-definitions/{processDefinitionId}/identitylinks/{family}/{identityId}',
            pathParams
        });
    }
    getIdentityLinksForFamily(processDefinitionId, family) {
        throwIfNotDefined(processDefinitionId, 'processDefinitionId');
        throwIfNotDefined(family, 'family');
        const pathParams = {
            processDefinitionId,
            family
        };
        return this.get({
            path: '/api/enterprise/process-definitions/{processDefinitionId}/identitylinks/{family}',
            pathParams
        });
    }
    getIdentityLinks(processDefinitionId) {
        throwIfNotDefined(processDefinitionId, 'processDefinitionId');
        const pathParams = {
            processDefinitionId
        };
        return this.get({
            path: '/api/enterprise/process-definitions/{processDefinitionId}/identitylinks',
            pathParams
        });
    }
    getProcessDefinitionDecisionTables(processDefinitionId) {
        throwIfNotDefined(processDefinitionId, 'processDefinitionId');
        const pathParams = {
            processDefinitionId
        };
        return this.get({
            path: '/api/enterprise/process-definitions/{processDefinitionId}/decision-tables',
            pathParams
        });
    }
    getProcessDefinitionForms(processDefinitionId) {
        throwIfNotDefined(processDefinitionId, 'processDefinitionId');
        const pathParams = {
            processDefinitionId
        };
        return this.get({
            path: '/api/enterprise/process-definitions/{processDefinitionId}/forms',
            pathParams
        });
    }
    getProcessDefinitionStartForm(processDefinitionId) {
        const pathParams = {
            processDefinitionId
        };
        return this.get({
            path: '/api/enterprise/process-definitions/{processDefinitionId}/start-form',
            pathParams
        });
    }
    getProcessDefinitions(opts) {
        return this.get({
            path: '/api/enterprise/process-definitions',
            queryParams: opts
        });
    }
    getRestFieldValues(processDefinitionId, field) {
        const pathParams = {
            processDefinitionId,
            field
        };
        return this.get({
            path: '/api/enterprise/process-definitions/{processDefinitionId}/start-form-values/{field}',
            pathParams
        });
    }
    getRestTableFieldValues(processDefinitionId, field, column) {
        const pathParams = {
            processDefinitionId,
            field,
            column
        };
        return this.get({
            path: '/api/enterprise/process-definitions/{processDefinitionId}/start-form-values/{field}/{column}',
            pathParams
        });
    }
}
